/* eslint-disable no-undef */
/* eslint-disable no-new */
(() => {
  new Swiper(".js-brands-slider", {
    preventInteractionOnTransition: true,
    freeMode: true,
    slidesPerView: "auto",
    spaceBetween: 24,
    autoplay: {
      delay: 0,
    },
    loop: true,
    speed: 4000,
  });
})();
